import React from 'react';
import apiclient from 'lib/apiclient';

export default function useArea()
{
    const [value, setValue] = React.useState([]);
    React.useEffect(() => {
        apiclient.get(`api/master/salesCoordinators`)
        .then(response => {
          setValue(response.data);
        });
    }, []);

    return value;
}